import Image from 'next/image';
import logoIcon from '../../../public/logo.svg';
export type ExpandingBadgeProps = {
    type?: string | null;
    has_subtitles?: string | null;
    has_dubbing?: string | null;
    alwaysOpen?: boolean
    hanging?: boolean
    invertOnHover?: boolean
}

const Badge = ({ hanging, alwaysOpen, invertOnHover, type, has_subtitles, has_dubbing }: ExpandingBadgeProps) => {
    const base =
        "h-5.5 w-5.5 min-w-5 px-0.5 mb-1 group/badge bg-secondary/75 text-neutral-50 overflow-hidden font-semibold !leading-none rounded-full hover:w-full max-w-max flex items-center transition-[width,background,color] duration-300 cursor-default";

    const shape = hanging ? "rounded-e-full" : "rounded-full";
    const width = alwaysOpen ? "w-max" : "hover:w-full";
    const hover = invertOnHover ? "hover:bg-secondary-50/90 hover:text-slate-900" : "";

    return (
        <div className="flex flex-col absolute top-2 right-2 z-50">
            {
                type === "exclusive" && (
                    <div className={`${base} ${shape} ${width} ${hover}`}>
                        <div className="flex place-content-center !min-w-4 !h-4">
                            <Image src={logoIcon} width={24} height={24} alt='اختصاصی ایده‌نما' />
                        </div>
                        <span className="text-[8px] whitespace-pre ms-1 pe-1">اختصاصی ایده‌نما</span>
                    </div>
                )
            }

            {
                has_subtitles && (
                    <div className={`${base} ${shape} ${width} ${hover}`}>
                        <div className="flex place-content-center !min-w-4 !h-4">
                            <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" className="max-w-max text-xs !w-4 !h-4"><g fill="none" stroke="currentColor" strokeLinecap="round" strokeWidth="1.6"><path d="M11 15.667A4.5 4.5 0 0 1 9.286 16C6.919 16 5 14.21 5 12s1.919-4 4.286-4c.61 0 1.189.119 1.714.333m8 7.334a4.5 4.5 0 0 1-1.714.333C14.919 16 13 14.21 13 12s1.919-4 4.286-4c.61 0 1.189.119 1.714.333"></path><path d="M22 12c0 4.714 0 7.071-1.465 8.535C19.072 22 16.714 22 12 22s-7.071 0-8.536-1.465C2 19.072 2 16.714 2 12s0-7.071 1.464-8.536C4.93 2 7.286 2 12 2s7.071 0 8.535 1.464c.974.974 1.3 2.343 1.41 4.536"></path></g></svg>
                        </div>
                        <span className="text-[8px] whitespace-pre ms-1 pe-1">زیرنویس فارسی</span>
                    </div>
                )
            }

            {
                has_dubbing && (
                    <div className={`${base} ${shape} ${width} ${hover}`}>
                        <div className="flex place-content-center !min-w-4 !h-4">
                            <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" className="max-w-max text-xs !w-4 !h-4"><g fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.6"><rect x="9" y="2" width="6" height="11" rx="3"></rect><path d="M5 10a7 7 0 0 0 14 0"></path><path d="M12 17v4"></path><path d="M8 22h8"></path></g></svg>
                        </div>
                        <span className="text-[8px] whitespace-pre ms-1 pe-1">دوبله فارسی</span>
                    </div>
                )
            }


        </div>
    );
};

export default Badge;